import Utility from '@/common/UtilityFunctions.js';

export default {
  anyChanges(state) {
    if (state.vueModel.Coverages.ChangedCoverModels === null) {
      return false;
    }

    return state.vueModel.Coverages.ChangedCoverModels.length > 0;
  },
  getChangedCovers(state) {
    return state.vueModel.Coverages.ChangedCoverModels;
  },
  changesAsList(state) {
    let str = '<ul>';

    for (var i in state.vueModel.Coverages.ChangedCoverModels) {
      str +=
        '<li>' +
        state.vueModel.Coverages.ChangedCoverModels[i].Name +
        ': ' +
        state.vueModel.Coverages.ChangedCoverModels[i].Value +
        '</li>';
    }

    str += '</ul>';

    return str;
  },
  changesLabel(state) {
    return state.vueModel.Price.ChangesLabel;
  },
  editModeButtonLabel(state) {
    return state.vueModel.EditContent.ButtonText;
  },
  effectiveDate(state) {
    return state.vueModel.IsRenewal ? state.vueModel.Renewal.StartDate : 'dags dato';
  },
  getVueModel(state) {
    return state.vueModel;
  },
  basketErrorText(state) {
    return state.vueModel.Price.BasketErrorText.replace(
      /\{phonenumber\}/g,
      (function () {
        switch (Utility.getBrand()[0]) {
          case 'runa':
            return '33485815';
          case 'bauta':
            return '33485812';
          case 'pfa':
            return '33485580';
          case 'lb':
            return '33485814';
          default:
            return '';
        }
      })()
    );
  },
  inRenewal(state) {
    return state.vueModel.IsRenewal;
  },
  isEditable(state) {
    return state.vueModel.IsEditable;
  },
  isEditingEnabled(state) {
    return state.vueModel.IsEditingEnabled;
  },
  portalId(state) {
    return state.vueModel.SaveEndorsementTemplate.PortalId;
  },
  additionalBasketProductInformationText(state) {
    return state.vueModel.Price.AdditionalBasketProductInformationText;
  },
  paymentTermsNoticeText(state) {
    return state.vueModel.Price.PaymentTermsNoticeText;
  },
  warningMessageList(state) {
    return state.vueModel.Modals.ConfirmSaveProposal.Content.WarningMessages;
  },
  getPolicyName(state) {
    return state.vueModel.PolicyName;
  }
};
